define(
    'utils/get-object-where',['jquery'],

    function ($) {
        return function (array, key, value) {
            var obj;

            for (var i = 0; i < array.length; i++) {
                obj = array[i];

                if (obj[key] === value) {
                    return obj;
                }
            }

            return null;
        };
    }
);
